import { TOUR_LOCALE_SUPPLEMENTS } from './tourLocaleSupplements.js';

/**
 * Multilingual tour copy for all supported UI locales.
 * @param {string} en
 * @param {string} ru
 */
export function M(en, ru) {
  const sup = TOUR_LOCALE_SUPPLEMENTS[en] || {};
  return {
    en,
    ru,
    es: sup.es || en,
    fr: sup.fr || en,
    zh: sup.zh || en,
    hi: sup.hi || en,
  };
}
